var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"height":_vm.height,"width":_vm.width ? _vm.width : 'auto',"hide-delimiters":""},scopedSlots:_vm._u([{key:"prev",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('LeftIcon',_vm._g(_vm._b({},'LeftIcon',attrs,false),on))]}},{key:"next",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('RightIcon',_vm._g(_vm._b({},'RightIcon',attrs,false),on))]}}])},_vm._l((_vm.imageList),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"contain":_vm.contain ? true : false,"src":item ? _vm.s3BucketURL + item : _vm.images[_vm.default_image],"reverse-transition":"fade-transition","transition":"fade-transition"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }